// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QeVc","colBig":"styles_colBig__jA_dH","colSmall":"styles_colSmall__28WBj"};